import EntryPoint from 'Engine/EntryPoint';
import AdaptiveBitmapText from 'Engine/base/bitmapText/AdaptiveBitmapText';
import MoneyFormat from 'Engine/base/moneyFormat/MoneyFormat';

export default class WinAmountAnimated {
  constructor(element, style = {}, fontName = 'boe-font') {

    this.label = new AdaptiveBitmapText('0', { ...element.style, ...style, fontName });
    this.label.anchor.set(0.5);
    // this.label.x = element.displayData.width / 2;
    this.label.y = element.displayData.height / 2;
    this.label.visible = false;
    element.removeChildren();
    element.addChild(this.label);

    this.onStop = () => {
    };
    this.onComplete = () => {
    };
    this.onChange = () => {};
  }

  setAdaptiveBox(width, height){
    this.label.setAdaptiveBox(width, height);
  }

  animate(startValue = 0, endValue, duration) {
    this.needStop = false;
    this.set(startValue);

    this.label.visible = true;
    this.startValue = startValue;
    this.endValue = endValue;
    this.duration = duration;
    this.startTime = Date.now();
    requestAnimationFrame(this._animateValueChanged.bind(this));
  }

  set(value) {
    this.label.text = MoneyFormat.cut(value);
    this.onChange(value)
  }

  stop() {
    this.needStop = true;
  }

  _onStop() {
    this.onStop();
    this.onComplete();
  };

  _animateValueChanged() {
    if (this.needStop) return;

    const time = Date.now() - this.startTime;

    if (time >= this.duration) {
      // this.label.text = MoneyFormat.formatCurrency(this.endValue, this._decimals, false);
      this.label.text = MoneyFormat.cut(this.endValue);
      this.onChange(this.endValue)
      return this._onStop();
    }

    const progress = time / this.duration;
    const amount = (this.endValue - this.startValue) * progress + this.startValue;
    // this.label.text = amount.toFixed(this._decimals);
    this.label.text = MoneyFormat.cut(amount);
    this.onChange(amount);
    requestAnimationFrame(this._animateValueChanged.bind(this));
  };

  set decimals(value) {
    this._decimals = value;
  }

  set fontSize(value) {
    this.label.fontSize = value;
  }

  set y(value) {
    value = Number(value);
    let y = this.label.parent.displayData.height / 2;
    if (value) y += value;
    this.label.y = y;
  }

  get scale() {
    return this.label.scale;
  }
}
